<template>
  <hm-content title>
    <div class="mb20">
    <div class="flex item-center mb20">
      <div class="ruleForm_title mr20">
        微信支付
      </div>
      <div class="flex item-center">
        <el-button type="primary" size="small" @click="addRule('wechat')">添加提现规则</el-button>
      </div>
    </div>
    <el-table
      :data="wechatList"
      style="width: 100%"
      ref="table"
      stripe
      border
      size="small"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
        :index="index => index + (wechatCurrentPage - 1) * wechatPageSize + 1"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="阶梯"
        prop="ruleMaxLimit"
      >
      <template slot-scope="scope">
        {{scope.row.ruleMinLimit}}-{{scope.row.ruleMaxLimit}}
      </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="账号类型"
        prop="type"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.type==='wechat'">微信</div>
          <div v-if="scope.row.type==='wechat_v3'">微信V3</div>
          <div v-if="scope.row.type==='alipay'">支付宝</div>
          <div v-if="scope.row.type==='bank'">银行卡</div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="账号"
        prop="sendName"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="单次支出上下线"
        prop="limit"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="单日支出上下线"
        prop="dayLimit"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="单月支出上下线"
        prop="monthLimit"
      ></el-table-column>
      <!-- <el-table-column
        header-align="center"
        align="center"
        label="关联提现规则"
        prop="ruleLimit"
      ></el-table-column> -->
      <el-table-column
        header-align="center"
        align="center"
        label="关联第三方协议"
        prop="contractName"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="是否兜底账号"
        prop="isDefault"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.isDefault==='1'">是</div>
          <div v-else>否</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        header-align="center"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <div class="flex flex-center">
            <el-button size="small" type="text" @click="edit(scope.row,'wechat')"
              >编辑</el-button
            >
            <!-- <el-button size="small" type="text" @click="record(scope.row)"
              >流水记录</el-button
            > -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="wechatTotal"
        @size-change="wechatHandleSizeChange"
        @current-change="wechatPaging"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="wechatCurrentPage"
      ></el-pagination>
    </div>
    </div>
    <div class="mb20">
    <div class="flex item-center mb20">
      <div class="ruleForm_title mr20">
        支付宝
      </div>
      <div class="flex item-center">
        <el-button type="primary" size="small" @click="addRule('alipay')">添加提现规则</el-button>
      </div>
    </div>
    <el-table
      :data="alipayList"
      style="width: 100%"
      ref="table"
      stripe
      border
      size="small"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
        :index="index => index + (alipayCurrentPage - 1) * alipayPageSize + 1"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="阶梯"
        prop="ruleMaxLimit"
      >
      <template slot-scope="scope">
        {{scope.row.ruleMinLimit}}-{{scope.row.ruleMaxLimit}}
      </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="账号类型"
        prop="type"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.type==='wechat'">微信</div>
          <div v-if="scope.row.type==='wechat_v3'">微信V3</div>
          <div v-if="scope.row.type==='alipay'">支付宝</div>
          <div v-if="scope.row.type==='bank'">银行卡</div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="账号"
        prop="sendName"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="单次支出上下线"
        prop="limit"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="单日支出上下线"
        prop="dayLimit"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="单月支出上下线"
        prop="monthLimit"
      ></el-table-column>
      <!-- <el-table-column
        header-align="center"
        align="center"
        label="关联提现规则"
        prop="ruleLimit"
      ></el-table-column> -->
      <el-table-column
        header-align="center"
        align="center"
        label="关联第三方协议"
        prop="contractName"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="是否兜底账号"
        prop="isDefault"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.isDefault==='1'">是</div>
          <div v-else>否</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        header-align="center"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <div class="flex flex-center">
            <el-button size="small" type="text" @click="edit(scope.row,'alipay')"
              >编辑</el-button
            >
            <!-- <el-button size="small" type="text" @click="record(scope.row)"
              >流水记录</el-button
            > -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="alipayTotal"
        @size-change="alipayHandleSizeChange"
        @current-change="alipayPaging"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="alipayCurrentPage"
      ></el-pagination>
    </div>
    </div>
    <div class="mb20">
    <div class="flex item-center mb20">
      <div class="ruleForm_title mr20">
        银行卡
      </div>
      <div class="flex item-center">
        <el-button type="primary" size="small" @click="addRule('bank')">添加提现规则</el-button>
      </div>
    </div>
    <el-table
      :data="bankList"
      style="width: 100%"
      ref="table"
      stripe
      border
      size="small"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
        :index="index => index + (bankCurrentPage - 1) * bankPageSize + 1"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="阶梯"
        prop="ruleMaxLimit"
      >
      <template slot-scope="scope">
        {{scope.row.ruleMinLimit}}-{{scope.row.ruleMaxLimit}}
      </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="账号类型"
        prop="type"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.type==='wechat'">微信</div>
          <div v-if="scope.row.type==='wechat_v3'">微信V3</div>
          <div v-if="scope.row.type==='alipay'">支付宝</div>
          <div v-if="scope.row.type==='bank'">银行卡</div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="账号"
        prop="sendName"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="单次支出上下线"
        prop="limit"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="单日支出上下线"
        prop="dayLimit"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="单月支出上下线"
        prop="monthLimit"
      ></el-table-column>
      <!-- <el-table-column
        header-align="center"
        align="center"
        label="关联提现规则"
        prop="ruleLimit"
      ></el-table-column> -->
      <el-table-column
        header-align="center"
        align="center"
        label="关联第三方协议"
        prop="contractName"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="是否兜底账号"
        prop="isDefault"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.isDefault==='1'">是</div>
          <div v-else>否</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        header-align="center"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <div class="flex flex-center">
            <el-button size="small" type="text" @click="edit(scope.row,'bank')"
              >编辑</el-button
            >
            <!-- <el-button size="small" type="text" @click="record(scope.row)"
              >流水记录</el-button
            > -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="bankTotal"
        @size-change="bankHandleSizeChange"
        @current-change="bankPaging"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="bankCurrentPage"
      ></el-pagination>
    </div>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1600px"
    >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="70px"
    >
      <div>
        <el-form-item class="mb10" label="阶梯:" prop="ruleLimit">
          <el-input
            clearable
            v-model.trim="ruleForm.ruleMinLimit"
            placeholder="请输入单月支出下限"
            size="small"
            class="ipt mr10"
            maxlength="10"
            style="width:150px;"
            @input="filterGt0OrFixed2('ruleMinLimit')"
          ></el-input>
          <span>-</span>
          <el-input
            clearable
            v-model.trim="ruleForm.ruleMaxLimit"
            placeholder="请输入单月支出上限"
            size="small"
            class="ipt ml10"
            maxlength="10"
            style="width:150px;"
            @input="filterGt0OrFixed2('ruleMaxLimit')"
          ></el-input>
          <div class="red">同一个支付渠道阶梯不允许交叉，不同支付渠道允许交叉</div>
          <div>选择账号</div>
        </el-form-item>
      </div>

      <el-table
        :data="accountlist"
        style="width: 100%"
        ref="accountTable"
        stripe
        border
        size="small"
        highlight-current-row
        @current-change="handleCurrentChange"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="账号类型"
          prop="accountType"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.type==='wechat'">微信</div>
            <div v-if="scope.row.type==='wechat_v3'">微信V3</div>
            <div v-if="scope.row.type==='alipay'">支付宝</div>
            <div v-if="scope.row.type==='bank'">银行卡</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="账号"
          prop="sendName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="单次支出上下限"
          prop="maxLimit"
        >
          <template slot-scope="scope">
            {{scope.row.minLimit}} - {{scope.row.maxLimit}}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="每日支出上下限"
          prop="dayMaxLimit"
        >
          <template slot-scope="scope">
            {{scope.row.dayMinLimit}} - {{scope.row.dayMaxLimit}}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="单月支出上下限"
          prop="monthMaxLimit"
        >
          <template slot-scope="scope">
            {{scope.row.monthMinLimit}} - {{scope.row.monthMaxLimit}}
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          label="关联提现规则"
          prop="ruleLimit"
        ></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          label="是否兜底账号"
          prop="isDefault"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.isDefault==='1'">是</div>
            <div v-else>否</div>
          </template>
        </el-table-column>
      </el-table>

      <div class="flex flex-center mt20">
        <el-button type="primary" size="small" @click="submitForm('ruleForm')"
          >保存</el-button
        >
        <el-button size="small" @click="dialogVisible = false"
          >取消</el-button
        >
      </div>
    </el-form>
    </el-dialog>
  </hm-content>
</template>

<script>
import area from "@/utils/area";
export default {
  components: {},
  data() {
    const patterndRuleFunc = (rule, val, callback) => {
      let falg = false;
      if(this.ruleForm.ruleMinLimit === "" || this.ruleForm.ruleMaxLimit === ""){
        falg = true;
        if (falg) {
          return callback(new Error("请输入必填项"));
        }
      }
      if(this.ruleForm.ruleMinLimit != "" && this.ruleForm.ruleMaxLimit != "" && parseInt(this.ruleForm.ruleMinLimit) > parseInt(this.ruleForm.ruleMaxLimit)){
        falg = true;
        if (falg) {
          return callback(new Error("请输入正确的阶梯"));
        }
      }
      callback();
    };
    return {
      addOrEdit: "",
      type: "",
      list: [],
      accountlist: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      title: "添加第三方签约",
      wechatList:[],
      wechatTotal: 0,
      wechatCurrentPage: 1,
      wechatPageSize: 10,
      alipayList:[],
      alipayTotal: 0,
      alipayCurrentPage: 1,
      alipayPageSize: 10,
      bankList:[],
      bankTotal: 0,
      bankCurrentPage: 1,
      bankPageSize: 10,
      ruleForm:{
        ruleMinLimit:"",
        ruleMaxLimit: "",
        mchId: "",
      },
      bankCardList: [
        {
          label: "微信",
          value: "wechat",
        },
        {
          label: "支付宝",
          value: "alipay",
        },
        {
          label: "银行卡",
          value: "bank",
        }
      ],
      rules: {
        ruleLimit: [
          {
            required: true,
            validator: patterndRuleFunc,
            trigger: "blur"
          }
        ],
      },
      listRow:[],
      currentRow:{},
      listCurrentRow: {},
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.queryListWechat();
    this.queryListAlipay();
    this.queryListBank();
  },
  methods: {
    async queryListWechat() {
      let params = {
        pageSize: this.wechatPageSize,
        pageNo: this.wechatCurrentPage,
        type: "wechat",
      };
      const { result } = await this.$store.dispatch(
        "getcashRuleQueryPageList",
        params
      );
      const { records, total } = result;
      this.wechatList = records;
      this.wechatTotal = total;
    },
    wechatPaging(page) {
      this.wechatCurrentPage = page;
      this.queryListWechat();
    },
    wechatHandleSizeChange(size) {
      this.wechatCurrentPage = 1;
      this.wechatPageSize = size;
      this.queryListWechat();
    },
    async queryListAlipay() {
      let params = {
        pageSize: this.alipayPageSize,
        pageNo: this.alipayCurrentPage,
        type: "alipay",
      };
      const { result } = await this.$store.dispatch(
        "getcashRuleQueryPageList",
        params
      );
      const { records, total } = result;
      this.alipayList = records;
      this.alipayTotal = total;
    },
    alipayPaging(page) {
      this.alipayCurrentPage = page;
      this.queryListAlipay();
    },
    alipayHandleSizeChange(size) {
      this.alipayCurrentPage = 1;
      this.alipayPageSize = size;
      this.queryListAlipay();
    },
    async queryListBank() {
      let params = {
        pageSize: this.bankPageSize,
        pageNo: this.bankCurrentPage,
        type: "bank",
      };
      const { result } = await this.$store.dispatch(
        "getcashRuleQueryPageList",
        params
      );
      const { records, total } = result;
      this.bankList = records;
      this.bankTotal = total;
    },
    bankPaging(page) {
      this.bankCurrentPage = page;
      this.queryListBank();
    },
    bankHandleSizeChange(size) {
      this.bankCurrentPage = 1;
      this.bankPageSize = size;
      this.queryListBank();
    },
    async queryList(type) {
      let params = {
        pageSize: 9999,
        pageNo: 1,
        type,
      };
      const { result } = await this.$store.dispatch(
        "getcashQueryPageList",
        params
      );
      const { records, total } = result;
      this.accountlist = records;
      this.total = total;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async addRule(type){
      this.addOrEdit = "add";
      this.dialogVisible = true;
      this.type = type;
      this.ruleForm.ruleMinLimit = "";
      this.ruleForm.ruleMaxLimit = "";
      this.currentRow = {};
      this.queryList(type);
      this.bankCardList.forEach(v => {
        if(type===v.value){
          this.title = "添加"+ v.label +"支付规则";
        }
      });
    },
    submitForm(formName){
      this.$refs[formName].validate(valid => {
        if (valid) {
          let name = "";
          let params = {};
          if(this.addOrEdit === "add"){
            name = "getcashRuleSave";
            params = {
              type: this.type,
              mchId: this.currentRow.id,
              ruleMinLimit:this.ruleForm.ruleMinLimit,
              ruleMaxLimit:this.ruleForm.ruleMaxLimit,
            };
          }else if(this.addOrEdit === "edit"){
            console.log("this.listCurrentRow:",this.listCurrentRow);
            console.log("this.currentRow:",this.currentRow);
            name = "getcashRuleUpdate";
            params = {
              type: this.type,
              mchId: this.currentRow.id,
              ruleMinLimit:this.ruleForm.ruleMinLimit,
              ruleMaxLimit:this.ruleForm.ruleMaxLimit,
              ruleId: this.listCurrentRow.id
            };
          }
          console.log("params:",params);
          this.$store.dispatch(name, params).then(res => {
            if (res.code == "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              if(this.type==='wechat'){
                this.queryListWechat();
              }else if(this.type==='alipay'){
                this.queryListAlipay();
              }else if(this.type==='bank'){
                this.queryListBank();
              }
              this.dialogVisible = false;
            }
          })
        }
      })
    },
    async edit(row,type){
      this.addOrEdit = "edit";
      console.log("row:",row);
      this.type = type;
      this.bankCardList.forEach(v => {
        if(type===v.value){
          this.title = "编辑"+ v.label +"支付规则";
        }
      });
      this.listCurrentRow = row;
      this.ruleForm.ruleMaxLimit = row.ruleMaxLimit;
      this.ruleForm.ruleMinLimit = row.ruleMinLimit;
      this.queryList(type).then(res=>{
        this.dialogVisible = true;
        this.accountlist.forEach((v,i)=>{
          if(v.id===row.mchId){
            this.setCurrent(this.accountlist[i])
          }
        })
      });
    },
    record(row){
      let mchId = row.mchId;
      console.log("mchId:",mchId);
      this.$router.push({
        name: "DealRecord",
        query: {
          mchId,
        },
      });
    },
    setCurrent(row) {
      this.$refs.accountTable.setCurrentRow(row);
    },
    handleCurrentChange(val) {
      this.currentRow = val;
      console.log("this.currentRow:",this.currentRow);
    },
    // 过滤大于0
    filterGt0(prop) {
      if (this.ruleForm[prop].length === 1) {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/[^0-9]/g, "");
      } else {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|\D/g, "");
      }
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.red{
  color: #E50065;
}
.ruleForm_title{
  font-size: 16px;
  font-weight: 600;
  color: #222222;
  &::before {
    display: inline-block;
    content: "";
    width: 4px;
    height: 14px;
    background: #e50065;
  }
}
</style>
